import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import ProjectListUI from '../../components/projectapp/project/ProjectListUI'

const ProjectListPageUI = ({context, messageList, errorList, projectList, filteredProjectList,
    alphaSort, timeSort, projectFilter, templateFilter, activeFilter, archivedFilter, searchFilter,
    onRefreshClick, onAlphaSortClick, onTimeSortClick, onProjectFilterClick, onTemplateFilterClick,
    onActiveFilterClick, onArchivedFilterClick, onSearchFilterChange
  }) =>
  <PrivatePageSF context={context} className='pg_projects'
    messageList={messageList} headerMessageKey='c_projects'
    centered={(!projectList && !errorList) || (projectList && projectList.length === 0)}
  >
    {
      !projectList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      projectList && projectList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        createLink='/projects/create'
        createLinkKey='c_create_project'
        createDisabledMessageKey='c_no_project_msg'
      />
    }
    {
      projectList && filteredProjectList && projectList.length !== 0 &&
      <div>
        <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_projects' />
        <ProjectListUI
          context={context}
          projectList={filteredProjectList}
          messageList={messageList}
          alphaSort={alphaSort}
          timeSort={timeSort}
          projectFilter={projectFilter}
          templateFilter={templateFilter}
          activeFilter={activeFilter}
          archivedFilter={archivedFilter}
          searchFilter={searchFilter}
          // events
          onRefreshClick={onRefreshClick}
          onAlphaSortClick={onAlphaSortClick}
          onTimeSortClick={onTimeSortClick}
          onProjectFilterClick={onProjectFilterClick}
          onTemplateFilterClick={onTemplateFilterClick}
          onActiveFilterClick={onActiveFilterClick}
          onArchivedFilterClick={onArchivedFilterClick}
          onSearchFilterChange={onSearchFilterChange}
        />
      </div>
    }
  </PrivatePageSF>

export default ProjectListPageUI
